var render = function render(){var _vm=this,_c=_vm._self._c;return _c('candidate-details-competencies-table',{attrs:{"report_title":_vm.$t('report.potential_score'),"items":_vm.potential_attrs,"fields":_vm.fields,"icon":'mdi mdi-finance',"job_table":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }